import { DATE_RELATIONS } from '@frontend/api';

export const SINGLE_DATE_DATE_RELATIONS = [
  DATE_RELATIONS.ON,
  DATE_RELATIONS.BEFORE,
  DATE_RELATIONS.AFTER,
] as const;
